<div class="w-full h-[200px] flex flex-col justify-center items-center">
  <span class="loader"></span>
  <p>انتظر قليــلا</p>
</div>